// extracted by mini-css-extract-plugin
module.exports = {"section":"SearchBooksetList__section","content":"SearchBooksetList__content"};